module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/modules/$.html.js
 ** module id = 54
 ** module chunks = 2
 **/